export function secondsToFormattedTime(seconds) {
    let milliseconds = seconds * 1000;

    let date = new Date(milliseconds);

    let hours = String(date.getUTCHours()).padStart(2, '0');
    let minutes = String(date.getUTCMinutes()).padStart(2, '0');
    let secs = String(date.getUTCSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${secs}`;
}